type VideoProvider = "vimeo" | "youtube" | "dailymotion" | "ina";

export function videoInfosFromUrl(url: string): { provider: VideoProvider; videoId: string } | null {
	const patterns = new Map<VideoProvider, RegExp>([
		["vimeo", /^(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:video\/)(\d+)$/],
		[
			"youtube",
			/^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((?:\w|-){11})/,
		],
		["dailymotion", /^(?:https?:\/\/)?(?:www\.)?(?:dai\.ly\/|dailymotion\.com\/)(?:video\/)?(\w+)/],
		["ina", /^(?:https?:\/\/)?player\.ina\.fr\/player\/embed\/([\w/]+)(?:\?.*)?/],
	]);

	for (const [provider, pattern] of patterns.entries()) {
		const groups = pattern.exec(url);
		if (groups) {
			return { provider, videoId: groups[1] };
		}
	}

	return null;
}
